
// import {updateSentFCMToken} from "../redux/actions/device";
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/auth";
import "firebase/analytics";
import { toast } from "react-toastify";
import APIClient from "../helpers/APIClient";
import { startsWith } from "lodash";
import { firebaseConfig } from "../constants/environment";
import UserManager from "./UserManager";
const publicVapidKey = "BArE4ecnbGarjO2lhF7jwxJnaPcxcM6QTvkgNCXDOOj452XUC9jqBKpQr0a07y2InGmF0_Bx74VhcHajZ0beGF8";
class FirebaseManager {
  _firebaseApp :any;
  _auth: any;
  _analytics: any;
  _messaging : any;
  _notifications : any;
  _store:any;
  _workerRegistration: any;
  _token: any;
  _confirmResultPhone: any;
  _tokenSent: any;
  initialize = async () => {
    if (this._firebaseApp) {
      return;
    }
    try {
      this._firebaseApp = firebase.initializeApp(firebaseConfig, 'app');
      console.log("initialize firebase :", this._firebaseApp);
      this._auth = this._firebaseApp.auth();
      this._analytics = this._firebaseApp.analytics();
      if (firebase.messaging.isSupported()) {
        this._messaging = this._firebaseApp.messaging();
        await this.registerServiceWorker();
        await this.requestPermission();
        this._messaging.usePublicVapidKey(publicVapidKey);
        this._messaging.onTokenRefresh(this._onTokenRefresh);
        this._messaging.onMessage(this._onMessage);
        await this._updateToken();
      }
    } catch (error) {
      console.log("initialize firebase error:", error);
    }
  };

  analytics = () => this._analytics;

  auth = () => {
    return this._auth;
  };

  updateStore = (store:any) => {
    if (this._store !== store) {
      this._store = store;
    }
  };

  getToken = ()=>{
    return this._token;
  }
  signInFacebook = async () =>{
    try {
      if (!this._auth) {
        return {
          error: new Error("Không thể đăng nhập tài khoản Facebook"),
        };
      }
      var provider = new firebase.auth.FacebookAuthProvider();
      this._auth.useDeviceLanguage();
     
      const result = await this._auth.signInWithPopup(provider);
      
      return {result};
    } catch (error:any) {
      console.error("error login with facebook: ", error);
      if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
        toast.error('Bạn đã đăng nhập với tài khoản google '+error.email+' trên panama');
      }
      return {error};
    }
  }

  signInWithPhone = async (phone:string) =>{
    try {
      if (!this._auth) {
        return {
          error: new Error("Không thể đăng nhập panama với số điện thoại"),
        };
      }
      const recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        "recaptcha-container", 
        {
          'size': 'invisible',
          'callback': ()=>{

          },
          'expired-callback': ()=>{
            recaptchaVerifier.render().then(function(widgetId) {
              // grecaptcha.reset(widgetId);
            })
          }
        }
      );
      try {
        this._confirmResultPhone = await this._auth.signInWithPhoneNumber(`+84${phone.replace("+84", "")}`, recaptchaVerifier);
        return {
          success: true
        };
      } catch (error:any) {
        if(error.code ==='auth/too-many-requests'){
          return {
            error : "SĐT đã bị chặn do đăng nhập quá nhiều lần liên tục."
          }
        }
        return {
          error: "Có lỗi xảy ra, vui lòng thử lại sau"
        }
      }
    } catch (error) {
      console.error("error login with phone: ", error);
      return {
        error: "Không thể đăng nhập panama với số điện thoại"
      };
    }
  }

  getIdToken = async (otp:any) => {
    try {
      const user = await this._confirmResultPhone.confirm(otp);
      const token = '';
      console.log(user)
      return {response: token};
    } catch (error:any) {
      console.log(error);
      switch (error.code) {
        case "auth/expired-verification-code":
          return {error: "Mã OTP đã hết hạn"};
          break;
        case "auth/invalid-verification-code":
          return {error: "Mã OTP không hợp lệ"};
        default:
          return {
            error: "Có lỗi xảy ra, vui lòng thử lại sau"
          };
      }
    }
};

  signInGoogle = async () => {
    try {
      if (!this._auth) {
        return {
          error: new Error("Không thể đăng nhập tài khoản Google"),
        };
      }
      const authProvider = new firebase.auth.GoogleAuthProvider();
      this._auth.useDeviceLanguage();
      const result = await this._auth.signInWithPopup(authProvider);
      return {result};
    } catch (error:any) {
      console.error("error login with google: ", error);
      if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
        toast.error('Tài khoản '+error.email +'đã được sử dụng trên panama');
      }
      return {error};
    }
  };

  registerServiceWorker = async () => {
    const cloudmess =  startsWith(window.location.href,'http://localhost') ? '/static/firebase/firebase-messaging-sw.js': '/static/firebase/firebase-messaging-sw.js'
    const cloudpush =  startsWith(window.location.href,'http://localhost') ? '/static/firebase/firebase-cloud-messaging-push-scope': '/static/firebase/firebase-cloud-messaging-push-scope'
    console.log("register service worker for messaging 1");
    if ( !this._messaging || this._workerRegistration) {
      return;
    }

    console.log("register service worker for messaging 2");
    try {

      const registration = await navigator.serviceWorker.register(
        cloudmess,
        {
          scope: cloudpush,
        }
      );
      console.log("register service worker for messaging successful");
      this._workerRegistration = registration;
      this._messaging.useServiceWorker(registration);
    } catch (error) {
      console.log("register service worker for messaging error:", error);
    }
  };

  /**
   * request notification permission
   */
  requestPermission = async () => {
    if (!window.Notification) {
      return;
    }

    try {
      console.log("Requesting notification permission...");
      const permission = await window.Notification.requestPermission();

      console.log("Notification permission granted");
      if (permission !== "granted") {
        console.log("Unable to get permission to notify.");
        return;
      }
    } catch (error) {
      console.log("request permission error:", error);
    }
  };

  _onTokenRefresh = () => {
    this._updateToken();
  };

  _updateToken = async () => {
    try {
      console.log("this messaging", this._messaging);
      if (!this._messaging) {
        return;
      }
      console.log("this messaging", this._messaging);

      const token = await this._messaging.getToken();
      this._token = token;
      // console.log("this messaging", this._firebaseApp.messaging().getToken());

      console.log("update token:", token);
      // // this._setTokenSentToServer(false);
      await this._sendTokenToServer(token);
    } catch (error) {
      console.log("update token error:", error);
      // this._setTokenSentToServer(false);
    }
  };

  _removeToken = async () => {
    try {
      console.log("this messaging", this._messaging);
      if (!this._messaging) {
        return;
      }
      console.log("this messaging", this._messaging);

      const token = await this._messaging.getToken();
      this._token = token;
      console.log("update token:", token);
      await this._removeTokenToServer(token);
    } catch (error) {
      console.log("update token error:", error);
    }
  };

  _sendTokenToServer = async (fcmToken: string) => {
    if(!fcmToken) return
    console.log("_sendTokenToServer:", fcmToken);
    console.log("isLogin", UserManager.isSignedIn());

    console.log("Sending token to server...:", fcmToken);

    if (UserManager.isSignedIn()) {
      const data = {
        fcmToken,
      };
      const {response} = await APIClient.POST(
        "/auth/fcm/registerToken",
        data
      );
      if (response && response.data) {
        this._setTokenSentToServer(true);
      }
    }
  };

  _removeTokenToServer = async (fcmToken: string) => {
    if(!fcmToken) return
    console.log("_sendTokenToServer:", fcmToken);
    console.log("isLogin", UserManager.isSignedIn());

    console.log("Sending token to server...:", fcmToken);

    if (UserManager.isSignedIn()) {
      const data = {
        fcmToken,
      };
      const {response} = await APIClient.POST(
        "/auth/fcm/unregisterUser",
        data
      );
      if (response && response.data) {
        this._setTokenSentToServer(false);
      }
    }
  };

  _onMessage = (payload:any) => {
    console.log("Message received. ", payload);
    if (this._workerRegistration) {
      const {data, notification} = payload;
      const title = notification.title;
      var options = {
        ...notification,
        data,
      };
      this._workerRegistration.showNotification(title, options);
    }
  };

  _isTokenSentToServer = () => {
    if (this._store) {
      return this._store.getState().device.sentFCMToken;
    }
    return this._tokenSent;
  };

  _setTokenSentToServer = (sent:boolean) => {

    this._tokenSent = !sent;
  };
}

export default new FirebaseManager()
